import { useEffect, useState } from 'react';
import { 
  AdMob, 
  BannerAdOptions, 
  BannerAdSize, 
  BannerAdPosition, 
  BannerAdPluginEvents,
  AdMobBannerSize,
  AdLoadInfo 
} from '@capacitor-community/admob';

const useBannerAd = () => {
  const [isAdLoaded, setIsAdLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const initializeAdMob = async () => {
      try {
        // Initialize AdMob
        await AdMob.initialize({
          testingDevices: ['EMULATOR'],
          initializeForTesting: true, // Set to false in production
        });
      } catch (err) {
        if (isMounted) {
          setError('Error initializing AdMob');
          console.error('AdMob initialization error:', err);
        }
      }
    };

    const showBanner = async () => {
      try {
        const options: BannerAdOptions = {
          adId: 'ca-app-pub-3940256099942544/6300978111',
          adSize: BannerAdSize.BANNER,
          position: BannerAdPosition.BOTTOM_CENTER,
          margin: 0,
          isTesting: true, // Set to false in production
        };

        await AdMob.showBanner(options);
      } catch (err) {
        if (isMounted) {
          setError('Error showing banner ad');
          console.error('Banner display error:', err);
        }
      }
    };

    const setupAdListeners = () => {
      // Banner loaded event
      AdMob.addListener(BannerAdPluginEvents.Loaded, () => {
        if (isMounted) {
          setIsAdLoaded(true);
          console.log('Banner loaded successfully');
        }
      });

    //   // Banner failed to load
    //   AdMob.addListener(BannerAdPluginEvents.FailedToLoad, (info: AdLoadInfo) => {
    //     if (isMounted) {
    //       setError(`Banner failed to load: ${info.error}`);
    //       console.error('Banner failed to load:', info);
    //     }
    //   });

      // Size changed event
      AdMob.addListener(BannerAdPluginEvents.SizeChanged, (size: AdMobBannerSize) => {
        console.log('Banner size changed:', size);
      });
    };

    const initialize = async () => {
      await initializeAdMob();
      setupAdListeners();
      await showBanner();
    };

    initialize();

    // Cleanup function
    return () => {
      isMounted = false;
      AdMob.hideBanner();
      AdMob.removeBanner();
    };
  }, []);

  return { isAdLoaded, error };
};

export default useBannerAd;